module.exports = __webpack_public_path__ + "images/festiveeed16342fcfb89168284565e5961a7d7.jpg";